/**
 * Created by h3 on 2017-08-29.
 */

import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Timeline, TimelineLite} from "gsap";
import {DungeonQuestSymbolUtil} from "../../utils/DungeonQuestSymbolUtil";

import {StateMatrix} from "../../utils/StateMatrix";
import {DungeonQuestGameConfig, DungeonQuestGameMode, DungeonQuestSymbols} from "../DungeonQuestGameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";


export class DungeonQuestNoWinPresentationController extends WinPresentationController {

    protected _noWinSymbols:StateReelSymbol[];
    private _symbolStates:StateMatrix<string>;
    private _masterTimeLine:TimelineLite | null;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "DungeonQuestNoWinPresentationController", skippable : false});
        this._noWinSymbols = [];
    }

    protected hasWin(): boolean {
        const retVal: boolean = (this._betWinsData == null || this._betWinsData.length == 0);
        if (!retVal) {
            this.tryRemoveZeroBetCounter();
        }
        return retVal;
    }

    protected startWinPresentation():void {
        this._symbolStates = new StateMatrix(5, 7, [0, 6], DungeonQuestGameConfig.instance.SYMBOL_STATES.normal.keyword);
        this._noWinSymbols = DungeonQuestSymbolUtil.getSymbolsWithState(this._symbolStates, DungeonQuestGameConfig.instance.SYMBOL_STATES.normal.keyword);

        for(let i:number = this._noWinSymbols.length - 1; i >= 0; i--) {
            const symbol = this._noWinSymbols[i];
            if(symbol.symName == DungeonQuestSymbols.S) {
                this._noWinSymbols.splice(i, 1);
            }
        }

        let tl:TimelineLite = new TimelineLite({
            onComplete: () => this.tryRemoveZeroBetCounter()
        });

        let noWinSymbolsAnimation:Timeline[] = DungeonQuestSymbolUtil.getSymbolStateAnimations(this._noWinSymbols, DungeonQuestGameConfig.instance.SYMBOL_STATES.normal, 0);
        tl.add(noWinSymbolsAnimation, 0);
        tl.add(() => this.finish());
        this._masterTimeLine = tl;
    }


    protected stopWinPresentation(isAborted:boolean):void {
        //Stuff that happens after complete dispatch
        if(this._masterTimeLine) {
            if(isAborted) {
                let isActive = this._masterTimeLine.isActive();
                if(isActive) {
                    this._masterTimeLine.seek(this._masterTimeLine.totalDuration(), true);
                    this._masterTimeLine.pause();
                    this._masterTimeLine.kill();
                }
            }
            this._masterTimeLine = null;
        }

        this._noWinSymbols = [];
    }

    private tryRemoveZeroBetCounter(): void {
        if (this._gameData && this._gameData.mode === DungeonQuestGameMode.FREESPIN && this._gameData.nextMode === DungeonQuestGameMode.NORMAL) {
            SlotGame.keypad.setZeroBetSpinCounter(-1);
        }
    }
}